import { withState } from 'recompose';

export default withState('email', 'updateEmail', '');
